import React from 'react'
import { string, func, oneOf } from 'prop-types'
import classnames from 'classnames'

const Form = ({
  action,
  method,
  onSubmit,
  className,
  children,
  ...otherProps
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form
      className={classnames('campus-form', className)}
      action={action}
      method={method}
      onSubmit={handleSubmit}
      {...otherProps}
    >
      { children }
    </form>
  )
}

Form.propTypes = {
  method: oneOf([
    'GET',
    'POST',
    'PUT',
    'PATCH',
    'DELETE',
  ]),
  action: string,
  onSubmit: func,
  className: string,
}

export default Form
